import PrecatoriosSelecionadas from './PrecatoriosSelecionadas/index';

export default PrecatoriosSelecionadas;